import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {LoginView} from "./loginView";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {ErrorBase} from "@/rawdogjs/src/core/ErrorBase";
import {BearerTokenApi} from "../../services/api/base/BearerTokenApi";
import {UserStore} from "../../data/stores/UserStore";
import {TenantApi} from "../../services/api/base/TenantApi";

export class LoginPresenter implements IPresenter {

    public _view: LoginView;
    private _router:Router;
    private _dependencyContainer: ParcelDependencyContainer;
    private _serverErrors: ErrorBase[] = [];

    constructor(loginView: LoginView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._view = loginView;
        this._router = router;
        this._dependencyContainer = dependencyContainer;
    }

    async initialize() {
        this._view.addOnClickHandler('#btn-login', async () => {
            await this.login();
        });
    }

    async login() {
        
        const authenticationApi = await this._dependencyContainer.resolve<BearerTokenApi>('BearerTokenApi');
        
        const loginResult = await authenticationApi.post({
                "createBearerTokenFromLogin": {
                    email: this._view.email,
                    password: this._view.password
                }
            },
            null,
            false,
            true
        );
        
        this._serverErrors = loginResult.data.errors;

        this._view.setErrorList(this._serverErrors);

        if(loginResult.data?.bearerToken) {
            const userStore = this._dependencyContainer.resolve<UserStore>('UserStore');
            const tenantApi = this._dependencyContainer.resolve<TenantApi>('TenantApi');
            await userStore.fetch(tenantApi);
            this._router.navigate('/#/home');
        }
        
    }

    inject() {
    }

}